module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated fadeIn",
    attrs: {
      "id": "modal-notifications",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card animated fadeInUp"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('span', {
    staticClass: "close-modal",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })]), _vm._v(" "), _c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('notifications_modal.notifications')))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "button-group"
  }, [_c('button', {
    staticClass: "left btn btn-default",
    class: {
      'active': _vm.showingNotifications
    },
    staticStyle: {
      "width": "50%"
    },
    on: {
      "click": _vm.showNotifications
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('notifications_modal.notifications')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "right btn btn-default",
    class: {
      'active': _vm.showingAnnouncements
    },
    staticStyle: {
      "width": "50%"
    },
    on: {
      "click": _vm.showAnnouncements
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('notifications_modal.announcements')) + "\n          "), (_vm.options.hasUnreadAnnouncements) ? _c('i', {
    staticClass: "fa fa-circle text-danger p-l-xs"
  }) : _vm._e()])]), _vm._v(" "), (_vm.options.loadingNotifications) ? _c('div', {
    staticClass: "notification-container"
  }, [_c('i', {
    staticClass: "fa fa-btn fa-spinner fa-spin"
  }), _vm._v("Loading Notifications\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.options.loadingNotifications && _vm.activeNotifications.length == 0) ? _c('div', {
    staticClass: "notification-container"
  }, [_c('div', {
    staticClass: "alert alert-warning m-b-none"
  }, [_vm._v("\n          We don't have anything to show you right now! But when we do, we'll be sure to let you know. Talk to you soon!\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.showingNotifications && _vm.hasNotifications) ? _c('div', {
    staticClass: "notification-container"
  }, _vm._l((_vm.options.notifications), function(notification) {
    return _c('div', {
      key: notification.id,
      staticClass: "notification"
    }, [_c('figure', [(notification.creator) ? _c('img', {
      staticClass: "spark-profile-photo",
      attrs: {
        "src": notification.creator.photo_url
      }
    }) : _c('span', {
      staticClass: "fa-stack fa-2x"
    }, [_c('i', {
      staticClass: "fa fa-circle fa-stack-2x"
    }), _vm._v(" "), _c('i', {
      class: ['fa', 'fa-stack-1x', 'fa-inverse', notification.icon]
    })])]), _vm._v(" "), _c('div', {
      staticClass: "notification-content"
    }, [_c('div', {
      staticClass: "meta"
    }, [_c('p', {
      staticClass: "title"
    }, [(notification.creator) ? _c('span', [_vm._v("\n                  " + _vm._s(notification.creator.name) + "\n                ")]) : _c('span')]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v("\n                " + _vm._s(_vm._f("relative")(notification.created_at)) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "notification-body",
      domProps: {
        "innerHTML": _vm._s(notification.parsed_body)
      }
    }), _vm._v(" "), (notification.action_text) ? _c('a', {
      staticClass: "button is-primary is-medium",
      attrs: {
        "href": notification.action_url
      }
    }, [_vm._v("\n              " + _vm._s(notification.action_text) + "\n            ")]) : _vm._e()])])
  })) : _vm._e(), _vm._v(" "), (_vm.showingAnnouncements && _vm.hasAnnouncements) ? _c('div', {
    staticClass: "notification-container"
  }, _vm._l((_vm.options.announcements), function(announcement) {
    return _c('div', {
      key: announcement.id,
      staticClass: "notification"
    }, [_c('figure', [_c('img', {
      staticClass: "spark-profile-photo",
      attrs: {
        "src": announcement.creator.photo_url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "notification-content"
    }, [_c('div', {
      staticClass: "meta"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("@" + _vm._s(announcement.creator.name))]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v("\n                " + _vm._s(_vm._f("relative")(announcement.created_at)) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "notification-body",
      domProps: {
        "innerHTML": _vm._s(announcement.parsed_body)
      }
    }), _vm._v(" "), (announcement.action_text) ? _c('a', {
      staticClass: "button is-primary is-medium",
      attrs: {
        "href": announcement.action_url
      }
    }, [_vm._v("\n              " + _vm._s(announcement.action_text) + "\n            ")]) : _vm._e()])])
  })) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed2ff094","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/notifications-modal.vue
// module id = 552
// module chunks = 0